import {
    EDIT_LOCATION_CRITERIA_REQUEST,
    EDIT_LOCATION_CRITERIA_SUCCESS,
    EDIT_LOCATION_CRITERIA_FAILURE,
} from '../constants/update_location_criteria.constants';

export const editLocationCriteriaRequest = (configId, locationCriteriaId, config) => ({
    type: EDIT_LOCATION_CRITERIA_REQUEST,
    configId,
    locationCriteriaId,
    config,
});

export const editLocationCriteriaSuccess = changedConfig => ({
    type: EDIT_LOCATION_CRITERIA_SUCCESS,
    changedConfig,
});

export const editLocationCriteriaFailure = error => ({
    type: EDIT_LOCATION_CRITERIA_FAILURE,
    error,
});



// WEBPACK FOOTER //
// ./src/modules/PlatformManagement/Lead-o-matic_location_update/redux/actions/edit_location_criteria.actions.js